import styled from "styled-components";

export const PhoneVerificationContainer = styled.div`
  padding: 20px 0;

  .form-error {
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
    margin-bottom: 0;
    line-height: 1.4;
  }

  .otp-title {
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    margin-bottom: 8px;
    font-family: "Geist", sans-serif;
  }

  .otp-description {
    font-size: 12px;
    color: #6b7280;
    margin-top: 8px;
    line-height: 1.4;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 32px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

export const SendCodeText = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: color 0.2s ease;

  color: #a4a7ae;
  font-family: "Geist", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;

  &:hover:not(:disabled) {
    color: #0056cc;
  }

  &:disabled {
    color: #a4a7ae;
    cursor: not-allowed;
    opacity: 0.75;
    background: transparent !important;
    border: none !important;
  }

  &:not(:disabled) {
    color: #0a7eff;
  }
`;

export const OtpContainer = styled.div`
  display: flex;
  gap: 8px;
  margin: 12px 0;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

export const OtpInput = styled.input`
  width: 44px;
  height: 44px;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #0a7eff;
    box-shadow: 0 0 0 3px rgba(10, 126, 255, 0.1);
    outline: none;
  }

  &.is-invalid {
    border-color: #dc3545;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
`;

export const PhoneInputWrapper = styled.div`
  .react-tel-input {
    position: relative;

    .flag-dropdown.country-code-btn {
      background: transparent !important;
      border: transparent !important;
    }
    .form-control {
      width: 100%;
      height: 44px;
      border: 1px solid #d5d7da;
      padding: 0.5rem 0.625rem;
      border-radius: 8px;
      font-size: 14px;
      padding-left: 3.5rem;
      background: #fff;
      box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
      transition: border-color 0.2s ease, box-shadow 0.2s ease;

      &:focus {
        border-color: #0a7eff;
        box-shadow: 0 0 0 3px rgba(10, 126, 255, 0.1);
        outline: none;
      }

      &.is-invalid {
        border-color: #dc3545;
      }
    }

    .selected-flag {
      position: absolute;
      left: 2px;
      top: 0px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent !important;
      border: none !important;
      cursor: pointer;
      font-size: 12px;
      font-weight: 600;
      color: #535862;
      z-index: 2;

      &::before {
        content: attr(data-country-code);
        font-size: 14px;
        font-weight: 500;
        color: #535862;
        margin-right: 4px;
      }

      &::after {
        content: "▼";
        top: 40%;
        right: -5px;
        position: absolute;
        font-size: 8px;
        color: #535862;
        margin-left: 2px;
      }
      &.open .selected-flag::after {
        content: "▲";
      }
    }

    .selected-flag .flag {
      display: none !important;
    }

    .selected-flag .selected-dial-code {
      display: none !important;
    }
    .country-list {
      border: 1px solid #d5d7da;
      border-radius: 8px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
      max-height: 200px;
      position: absolute;
      background: white;
      z-index: 1000;
      .country {
        padding: 8px 12px;
        font-size: 14px;

        &:hover {
          background-color: #f9fafb;
        }

        .flag {
          margin-right: 8px;
        }
      }
    }
  }
`;
